<script setup lang="ts">
import { type ShallowRef, computed, shallowRef, watchEffect } from 'vue'
import type { ILabelProps } from '../types'
import useInputConfig from '../composables/useInputConfig'

defineOptions({
    inheritAttrs: false,
})

const props = defineProps<ILabelProps>()

const disabled = computed(() => props.state === 'disabled')

const combinedLabel = computed(() => {
    const labelText = props.label
    const asteriskClasses = {
        'ml-1': true,
        'text-disabled': disabled.value,
        'text-validation-danger': !disabled.value,
    }

    if (props.required) {
        return {
            text: labelText,
            asterisk: {
                classes: asteriskClasses,
                content: '*',
            },
        }
    }

    return {
        text: labelText,
    }
})

const config: ShallowRef<Record<string, string>> = shallowRef({} as Record<string, string>)

watchEffect(() => {
    config.value = useInputConfig({
        state: props.state,
    })
})
</script>

<template>
    <div class="mb-1 flex items-end justify-between">
        <label
            v-if="props.label"
            :class="config.labelClasses"
            :for="props.id"
        >
            {{ combinedLabel.text }}
            <span
                v-if="combinedLabel.asterisk"
                :class="combinedLabel.asterisk.classes"
            >
                {{ combinedLabel.asterisk.content }}
            </span>
        </label>

        <div
            v-if="props.counter"
            :class="config.counterClasses"
        >
            {{ String(modelValueLength) || '0' }} / {{ props.maxLength || 100 }}
        </div>
    </div>
</template>
